import type { KybSubmissionItem as KybSubmissionDetail } from '../../../api/src/lib/getAllKybSubmissions';
import { Store } from '@tanstack/react-store';
import type { SortingState } from '@tanstack/react-table';
import type { KybStatus } from '../../../api/src/types/database';
import { createManagementActions } from './createManagementStore';

export type { KybSubmissionDetail };

interface KybManagementState {
  submissions: KybSubmissionDetail[];
  filters: {
    status: KybStatus | 'all';
    search: string;
  };
  sorting: SortingState;
  pagination: {
    currentPage: number;
    totalPages: number;
    total: number;
  };
  summary: {
    totalByStatus: Record<KybStatus, number>;
    approvalRate: number;
    averageProcessingTime?: number;
  } | null;
  ui: {
    isLoading: boolean;
    selectedSubmissionId: string | null;
  };
}

const initialFilters: KybManagementState['filters'] = {
  status: 'all',
  search: '',
};

const defaultSorting: SortingState = [{ id: 'submittedAt', desc: true }];

export const kybManagementStore = new Store<KybManagementState>({
  submissions: [],
  filters: initialFilters,
  sorting: defaultSorting,
  pagination: { currentPage: 1, totalPages: 1, total: 0 },
  summary: null,
  ui: { isLoading: true, selectedSubmissionId: null },
});

const actions = createManagementActions(kybManagementStore, {
  initialFilters,
  defaultSorting,
});

export const {
  updateFilter,
  setSorting,
  setPage,
  setPaginationInfo,
  setLoading,
} = actions;

export const setSubmissions = (submissions: KybSubmissionDetail[]) => {
  kybManagementStore.setState((prev) => ({ ...prev, submissions }));
};

export const setSummary = (summary: KybManagementState['summary']) => {
  kybManagementStore.setState((prev) => ({ ...prev, summary }));
};

export const selectSubmission = (submissionId: string | null) => {
  actions.setUiField('selectedSubmissionId', submissionId);
};
